import React, {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import useErrorBoundary from "use-error-boundary";
import {useSnackbar} from 'components/organisms/Providers/SnackbarProvider/SnackbarProvider';
import ErrorPage from 'components/pages/Error/ErrorPage/ErrorPage';
import logger from 'helpers/logger';
import CenterWrapper from 'components/templates/Wrappers/Basic/CenterWrapper/CenterWrapper';
import Icon from 'components/atoms/Icons/Icon/Icon';
import Close from '@mui/icons-material/Close';

const ErrorProvider = (props) => {
  const {
    showSnackbar,
    children
  } = {
    showSnackbar: true,
    ...props
  };

  const [errorPage, setErrorPage] = useState(false);

  const snackbar = useSnackbar();

  const {ErrorBoundary, didCatch, error, reset} = useErrorBoundary((error, errorInfo) => {
    // For logging/reporting
    logger.error('Error', error, errorInfo);
  })

  const resetError = useCallback(() => {
    setErrorPage(false);
    reset();
  }, [reset]);

  useEffect(() => {
    if (didCatch) {
      setErrorPage((current) => !current ? true : current);
      if (showSnackbar) {
        snackbar.show(`Something went very wrong: ${error.message}`, 'Close',
          {color: 'error', autoHideDuration: null, ButtonProps: { startIcon: <Icon icon={Close}/> }}, resetError, null, false);
      }
    }
  }, [error, didCatch, showSnackbar, snackbar, resetError]);

  if (didCatch && errorPage) {
    return <CenterWrapper centerWidth={800}><ErrorPage error={error} /></CenterWrapper>
  } else {
    return <ErrorBoundary>
      {children}
    </ErrorBoundary>
  }
};

ErrorProvider.propTypes = {
  showSnackbar: PropTypes.bool
}

export default ErrorProvider;
